@if (overview(); as o) {
  <!-- Masthead: "пулс на пазара" -->
  <section class="masthead">
    <div class="mast-copy">
      <span class="eyebrow">Национален пулс · {{ periodLabel() }}</span>
      <h1>
        Жилищният пазар днес:
        <b class="big-num">{{ fmtEurPerM2(o.price.headline) }}</b>
      </h1>
      <!-- Count from the data, not from prose: the tracked set went from
           12 seeded cities to the 27 the crawl actually finds. -->
      <p class="lead">
        Медианна офертна цена на активните обяви за продажба в
        {{ o.cities.length }} наблюдавани града.
      </p>
      <div class="mast-chips">
        <app-delta-chip [value]="o.price.momPct" label="МоМ" />
        <app-delta-chip [value]="o.price.yoyPct" label="ГоГ" />
      </div>
    </div>
    <div class="mast-gauge card">
      <span class="gauge-label">Индекс на прегряване</span>
      <app-gauge-chart [score]="o.overheating.score" />
      <p class="gauge-note">
        Цени {{ o.overheating.priceYoY | pct }} ГоГ срещу доходи
        {{ o.overheating.incomeYoY | pct }} и наеми {{ o.overheating.rentYoY | pct }}.
      </p>
    </div>
  </section>

  <app-market-notice />

  <section class="controls">
    <h2>Тенденция на цените</h2>
    <span class="toggles">
      <app-range-toggle [value]="rangeMonths()" (change)="rangeMonths.set($event)" />
      <app-granularity-toggle [value]="granularity()" (change)="granularity.set($event)" />
    </span>
  </section>

  <div class="grid cols-2 charts-row">
    <div class="card">
      <h3>Цена срещу обем на сделките</h3>
      <app-trend-chart
        [data]="priceChartSeries(o)"
        [dualAxis]="true"
        ariaLabel="Цена на кв.м срещу брой сключени сделки — разминаването е водещ индикатор"
      />
    </div>
    <div class="card">
      <h3>Активни обяви за продажба</h3>
      <app-trend-chart
        [data]="[{ name: 'Обяви', series: ranged(o.inventory.series) }]"
        kind="bar"
        ariaLabel="Брой активни обяви по период"
      />
    </div>
  </div>

  <div class="grid cols-4 kpi-row">
    <app-kpi-card
      label="Сделки / тримесечие"
      [value]="fmtInt(o.transactions.headline)"
      [badge]="o.transactions.isInProgress ? 'в ход' : null"
      [sub]="o.transactions.progressSub ?? 'вписани сделки (Агенция по вписванията)'"
      [mom]="o.transactions.momPct"
      [yoy]="o.transactions.yoyPct"
    />
    <app-kpi-card
      label="Лихва по ипотеки"
      [value]="fmt2(o.mortgageRate.headline) + ' %'"
      sub="синтетичен БНБ-стил индикатор"
      [yoy]="o.mortgageRate.yoyPct"
      [invert]="true"
    />
    <app-kpi-card
      label="Брутна доходност от наем"
      [value]="fmt2(o.rentalYieldPct) + ' %'"
      sub="годишен наем ÷ цена, национално"
    />
    <!-- topMovers is empty until there is a year to compare against, and
         indexing [0] of an empty array threw, taking the whole page down
         with it — the header rendered and everything below it vanished. -->
    @if (o.topMovers[0]; as top) {
      <app-kpi-card
        label="Най-бърз ръст (ГоГ)"
        [value]="top.city.name"
        [sub]="'+' + (top.yoyPct | pct: false)"
      />
    } @else {
      <app-kpi-card
        label="Най-бърз ръст (ГоГ)"
        value="—"
        sub="нужна е година наблюдения"
      />
    }
  </div>

  <h2>Градовете под лупа</h2>
  <div class="grid cols-3 city-grid">
    @for (c of o.cities; track c.city.id) {
      <a class="card city-card" [routerLink]="['/grad', c.city.slug]">
        <div class="city-head">
          <span class="city-name">{{ c.city.name }}</span>
          <app-delta-chip [value]="c.yoyPct" label="ГоГ" />
        </div>
        <span class="city-price">{{ fmtEurPerM2(c.medianEurPerM2) }}</span>
        <app-sparkline [series]="c.sparkline" />
        <div class="city-foot">
          <span>{{ fmtInt(c.activeListings) }} обяви</span>
          <span>доходност {{ fmt2(c.rentalYieldPct) }}%</span>
          @if (c.overheatingScore !== null) {
            <span [class.hot]="c.overheatingScore > 65">прегряване {{ c.overheatingScore }}</span>
          } @else {
            <span class="muted" title="Нужна е поне година история">прегряване —</span>
          }
        </div>
      </a>
    }
  </div>
} @else {
  <p class="loading">Зареждане на пазарните данни…</p>
}
